import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import { cleanInput } from "../../../../helpers/cleanInput";
import Location from "../../../../components/includes/location";
import PersonalDetails from "./personalDetails";
import ShippersRate1 from "./shippersRate1";
import ShippersRate2 from "./shippersRate2";
import {
  editShipper,
  showShipper,
} from "../../../../redux/shippers/shippersActions";

export default function EditShipper() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [active_tab, setActiveTab] = useState("personal details");
  const { shipper } = useSelector((state) => state.shipper);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });

  const fromJson = (value) => JSON.parse(value);

  let [phone, setPhone] = useState("");
  const [data, setData] = useState({
    currency: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    insurance_percentage: "",
    tax_percentage: "",
    discount_percentage: "",
    vat_percentage:"",
    base_fee: "",
    base_fee_per_meter: "",
    base_fee_per_kilogram: [],
    base_fees_by_delivery_mode: [],
    weight_limit_by_kilogram: "",
  });
  const {
    address,
    currency,
    city,
    state,
    country,
    zip,
    insurance_percentage,
    base_fee_per_meter,
    tax_percentage,
    discount_percentage,
    base_fee,
    base_fees_by_delivery_mode,
    base_fee_per_kilogram,
    weight_limit_by_kilogram,
  } = data;

  useEffect(() => {
    if (id) {
      dispatch(showShipper(id));
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    setData({
      address: shipper?.address,
      currency: shipper?.currency,
      city: shipper?.city,
      state: shipper?.state,
      country: shipper?.country,
      zip: shipper?.zip,
      insurance_percentage: Math.trunc(shipper?.insurance_percentage),
      base_fee_per_meter: shipper?.base_fee_per_meter,
      tax_percentage: Math.trunc(shipper?.tax_percentage),
      discount_percentage: Math.trunc(shipper?.discount_percentage),
      vat_percentage: Math.trunc(shipper?.vat_percentage),
      base_fee: shipper?.base_fee,
      base_fees_by_delivery_mode: shipper?.base_fees_by_delivery_mode,
      base_fee_per_kilogram: shipper?.base_fee_per_kilogram,
      weight_limit_by_kilogram: shipper?.weight_limit_by_kilogram,
    });
    setPhone(shipper?.phone);
  }, [shipper]);

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };

  const handleNext = () => {
    setSubmitted(true);
    if (
      phone &&
      address &&
      city &&
      state &&
      address &&
      country &&
      zip &&
      currency
    ) {
      setActiveTab("shippers-Rate-1");
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleNext2 = () => {
    setSubmitted(true);
    if (
      base_fee_per_meter &&
      insurance_percentage &&
      tax_percentage &&
      discount_percentage &&
      base_fee
    ) {
      setActiveTab("shippers-Rate-2");
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const removebyDelivery = (value) => {
    setData({ ...data, base_fees_by_delivery_mode: value });
  };

  const handleBack = () => {
    setActiveTab("personal details");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleBack2 = () => {
    setActiveTab("shippers-Rate-1");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  // phone = phone?.slice(1);

  const handleSubmit = async () => {
    // cleanInput(data);
    setSubmitted(true);

    if (
      currency &&
      insurance_percentage &&
      phone &&
      base_fee_per_meter &&
      address &&
      city &&
      state &&
      country &&
      base_fees_by_delivery_mode &&
      base_fee_per_meter &&
      base_fee_per_kilogram &&
      zip &&
      weight_limit_by_kilogram
    ) {
      const response = await dispatch(editShipper({ ...data, id: id, phone }));
      if (response) {
        navigate("/admin/shippers/unapproved/1");
      }
    }
  };

  return (
    <>
      <div className="pt-4 sm:pt-2 sm:flex items-center mx-auto">
        <div className="max-w-4xl mx-auto">
          {active_tab === "personal details" && (
            <PersonalDetails
              handleChange={handleChange}
              data={data}
              phone={phone}
              setPhone={setPhone}
              handleSubmit={handleSubmit}
              submitted={submitted}
              Location={Location}
              locationId={locationId}
              locationList={locationList}
              setLocationList={setLocationList}
              setLocationId={setLocationId}
              handleRegion={handleRegion}
              handleNext={handleNext}
            />
          )}
          {active_tab === "shippers-Rate-1" && (
            <ShippersRate1
              handleChange={handleChange}
              handleBack={handleBack}
              data={data}
              handleSubmit={handleSubmit}
              submitted={submitted}
              handleNext2={handleNext2}
            />
          )}
          {active_tab === "shippers-Rate-2" && (
            <ShippersRate2
              handleChange={handleChange}
              handleBack2={handleBack2}
              // removebyKilogram={removebyKilogram}
              removebyDelivery={removebyDelivery}
              data={data}
              setData={setData}
              handleSubmit={handleSubmit}
              submitted={submitted}
              // handleDefault={handleDefault}
            />
          )}
        </div>
      </div>
    </>
  );
}
